var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 516,
    height: 516,
    viewBox: "0 0 516 516",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_148_426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3933 258H125.009",
    stroke: "currentColor",
    strokeWidth: 50,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.83 25.5676V125.181",
    stroke: "currentColor",
    strokeWidth: 50,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.266 258H390.65",
    stroke: "currentColor",
    strokeWidth: 50,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.83 490.432V390.819",
    stroke: "currentColor",
    strokeWidth: 50,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4641 422.363L163.903 351.926",
    stroke: "currentColor",
    strokeWidth: 50,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4641 93.6374L163.903 164.075",
    stroke: "currentColor",
    strokeWidth: 50,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.194 93.6374L351.754 164.075",
    stroke: "currentColor",
    strokeWidth: 50,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.194 422.363L351.754 351.926",
    stroke: "currentColor",
    strokeWidth: 50,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_148_426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 516,
    height: 516,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.159ef83d1460a60464f8c4dabd006868.svg";
export { ForwardRef as ReactComponent };